import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import LoadingScreen from './LoadingScreen';

const AuthCallback = () => {
  const { completeOAuthSignin, saveGoogleAvatar, isAuthenticated, loading: authLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    // If we're already authenticated, just go to dashboard
    if (isAuthenticated && !authLoading) {
      navigate('/dashboard', { replace: true });
      return;
    }

    const run = async () => {
      try {
        const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        const queryParams = new URLSearchParams(window.location.search);

        const accessToken = hashParams.get('access_token') || queryParams.get('access_token');
        const refreshToken = hashParams.get('refresh_token') || queryParams.get('refresh_token');

        if (!accessToken) {
          // If no token in URL, check if we actually have it in storage already
          if (localStorage.getItem('access_token')) {
            navigate('/dashboard', { replace: true });
            return;
          }
          throw new Error('No authentication session found. Please try signing in again.');
        }

        await completeOAuthSignin(accessToken, refreshToken);
        await saveGoogleAvatar();

        navigate('/dashboard', { replace: true });
      } catch (err) {
        setError(err.message || 'Google sign in callback failed');
      }
    };

    run();
  }, [completeOAuthSignin, saveGoogleAvatar, navigate]);

  if (error) {
    return (
      <div className="auth-error-screen" style={{ 
        height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', 
        background: '#000', color: '#ef4444', textAlign: 'center' 
      }}>
        <div>
          <h2>Authentication Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return <LoadingScreen />;
};

export default AuthCallback;
